import useUI from 'hooks/use-ui';
import useDispensary from 'src/dispensary/hooks/use-dispensary';

import useStoreFrontOrigin from './use-store-front-origin';

export default function useStoreFrontAbsoluteUrl(): string | undefined {
  const storeFrontOrigin = useStoreFrontOrigin();
  const { dispensaryRootUrl } = useUI();
  const { dispensary } = useDispensary();

  if (!dispensary?.cName) {
    return undefined;
  }

  return `${storeFrontOrigin}/${dispensaryRootUrl}/${dispensary.cName}`;
}
